<template>
    <div class="steps">
        <div class="info">
            <span>{{ $t("Product configurator") }}</span>
            <span></span>
        </div>
        <router-link class="step" tag="div" to="/" event="" v-if="step === 1">
            <a>
                <span>1</span>
                <span> {{ $t("Product selectie") }}</span>
                <span></span>
            </a>
        </router-link>
        <router-link class="step" tag="div" to="/" exact v-if="step !== 1" >
            <a>
                <span>1</span>
                <span>{{ $t("Product selectie") }}</span>
                <span></span>
            </a>
        </router-link>
        <router-link class="step" tag="div" to="/steptwo" v-if="step < 2" event="">
            <a>
                <span>2</span>
                <span>{{ $t("Mechanismes") }}</span>
                <span></span>
            </a>
        </router-link>
        <router-link class="step" tag="div" to="/steptwo" exact v-if="step >= 2" >
            <a>
                <span>2</span>
                <span>{{ $t("Mechanismes") }}</span>
                <span></span>
            </a>
        </router-link>
        <router-link class="step" tag="div" to="/stepthree" v-if="step < 3" event="">
            <a>
                <span>3</span>
                <span>{{ $t("Opties en kaders") }}</span>
                <span></span>
            </a>
        </router-link>
        <router-link class="step" tag="div" to="/stepthree" exact v-if="step >= 3" >
            <a>
                <span>3</span>
                <span>{{ $t("Opties en kaders") }}</span>
                <span></span>
            </a>
        </router-link>
        <router-link class="step" tag="div" to="/stepfour" v-if="step < 4" event="">
            <a>
                <span>4</span>
                <span>{{ $t("Resultaat") }}</span>
                <span></span>
            </a>
        </router-link>
        <router-link class="step" tag="div" to="/stepfour" exact v-if="step >= 4" >
            <a>
                <span>4</span>
                <span>{{ $t("Resultaat") }}</span>
                <span></span>
            </a>
        </router-link>
    </div>
</template>

<script>
    import { EventBus } from '../../services/eventBus'

    export default {
      data() {
        return {
            step: 4
        }
      },
        name: "Steps",
      methods: {
        CheckRoute(){
          let route = this.$route.name
          if(route === 'StepOne') {
            this.step = 1
          }
          if(route === 'StepTwo') {
            this.step = 2

          }
          if(route === 'StepThree') {
            this.step = 3

          }
          if(route === 'StepFour') {
            this.step = 4
          }
        }

      },
      mounted: function () {
        EventBus.$on('routeChange', this.CheckRoute)
      }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/general/Steps.vue